import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TweenMax, Quint } from 'gsap';

import { ListItem } from '../../../shared/list-confirmation/model/list-item';

import { AppEventDispatcher } from './../../../utils/AppEventDispatcher';
import { EventTypes } from './../../../shared/EventTypes';

import { PaymentFederalTaxes } from './../models/payment-federal-taxes';

import { PaymentFederalTaxesEventType } from './../payment-federal-taxes.event.type';
import { PaymentFederalTaxesService } from './../payment-federal-taxes.service';

@Component({
	selector: 'app-payment-result-darf',
	templateUrl: './payment-result-darf.component.html',
	styleUrls: ['./payment-result-darf.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PaymentResultDarfComponent implements OnInit, OnDestroy {

	@Input() paymentData: PaymentFederalTaxes;

	public form: FormGroup;
	private view = '[data-component="payment-result-darf"]';
	private today: number = Date.now();
	private viewHeight = 0;

	active = false;
	hasSubimited = false;
	confirmList: Array<ListItem> = [];

	imagesTax: Array<string> = [
		'assets/imgs/dashboard/ministe-rio-da-fazenda.png',
		'assets/imgs/dashboard/1200-px-logo-receita-federal-do-brasil-svg.png'
	];
	descriptionTax: String = `Ministério da Fazenda - Secretaria da Receita Federal <br>DARF (Documento de Arrecadação de Receitas Federais)`;

	constructor(private paymentService: PaymentFederalTaxesService) {	}

	ngOnInit() {
		AppEventDispatcher.listen( PaymentFederalTaxesEventType.STEPS_DARF.RESULT_DARF, () => {
			this.active = true;
			this.show();
		});
	}

	show() {
		const interval = setInterval(() => {

			if ($(this.view).length > 0) {
				const containerHeight = this.getStepHeight();

				this.viewHeight = containerHeight;

				TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut});
				TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut});
				TweenMax.to('.buttons', .8, {delay: .8, bottom: 0, ease: Quint.easeOut});

				clearInterval(interval);
			}

		}, 10);
	}

	hide() {
		this.removeListeners();

		TweenMax.to(this.view, .8, { delay: .4, left: '-100%', ease: Quint.easeOut, onComplete: () => {
			this.active = false;
		}});
	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight() + 60;
	}

	ngOnDestroy() {
		this.removeListeners();
	}

	removeListeners() {
		AppEventDispatcher.removeListener( PaymentFederalTaxesEventType.STEPS_DARF.RESULT_DARF );
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/payment-federal-taxes/payment-result-darf/payment-result-darf.component.ts